const Role = Object.freeze({
  DOCTOR: 1,
  SPEAKER: 2,
  NOTARY: 3,
  CARRIER: 4,
  THANATO: 5,
  SUPPLIER: 6,
})

export default Role
